import React from 'react';
import '../Welcome/Welcome.css';

const Welcome = () => {
  return (
    <section className="welcome-section">
      <div className="welcome-content">
        <h1>
          Welcome to <span className="highlight">Events</span>
        </h1>
        <p className="welcome-subheading">
          From Wedding Celebrations and Birthday Parties to Corporate Gatherings and Musical Performances,
          we deliver a full spectrum of event management services tailored to your needs and budget.
        </p>
      </div>

      <div className="welcome-features">
        <div className="feature-card">
          <img src='/w1.webp' className='f-i' alt='wedding-image' loading="lazy" />
        </div>

        <div className="feature-card">
          <img src='/w2.jpeg' className='f-i' alt='wedding-image' loading="lazy" />
        </div>

        <div className="feature-card">
          <img src='/w3.jpeg' className='f-i' alt='wedding-image' loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default Welcome;
